function init() {
	for (const form of document.querySelectorAll("form[data-ajax]")) {
		const formHandle = form.getAttribute("data-handle");

		form.addEventListener("freeform-ajax-success", function (event) {
			const response = event.response;
			console.log(response);
			dataLayer.push({
				event: "formSubmission",
				formHandle: formHandle,
				submissionID: response.submissionId,
			});
		});
	}
}

export default init;
